import CryptoJS from "crypto-js";
const SESSION_ENCRYPTION_KEY = "restoqueen_waiter_session_cache_v1";

export const getEncryptedSessionData = <T>(key: string): T | null => {
    try {
        const encryptedValue = sessionStorage.getItem(key);
        if (!encryptedValue) return null;
        const bytes = CryptoJS.AES.decrypt(encryptedValue, SESSION_ENCRYPTION_KEY);
        const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);
        if (!decryptedValue) return null;
        return JSON.parse(decryptedValue) as T;
    } catch {
        sessionStorage.removeItem(key);
        return null;
    }
};

export const setEncryptedSessionData = <T>(key: string, value: T): void => {
    try {
        const encryptedValue = CryptoJS.AES.encrypt(
            JSON.stringify(value),
            SESSION_ENCRYPTION_KEY
        ).toString();
        sessionStorage.setItem(key, encryptedValue);
    } catch {
        // Ignore storage errors to avoid breaking API flow.
    }
};
